"use client";

import React from "react";

/**
 * Put inside a <form>. Adds the two fields lib/formGuard.ts checks: a text
 * field people never see (scripts fill in everything), and how long the form
 * was open, in milliseconds. The time is written on "submit", directly on the
 * form, which runs before React's onSubmit reads the form with `new FormData`.
 */
const FormGuard = () => {
  const fillTime = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    const input = fillTime.current;
    const form = input?.form;
    if (!input || !form) return;
    const openedAt = Date.now();
    const stamp = () => {
      input.value = String(Date.now() - openedAt);
    };
    form.addEventListener("submit", stamp);
    return () => form.removeEventListener("submit", stamp);
  }, []);

  return (
    <>
      <input ref={fillTime} type="hidden" name="form_fill_ms" defaultValue="" />
      <div aria-hidden="true" className="absolute -left-[10000px] h-px w-px overflow-hidden">
        <label>
          Website
          <input type="text" name="website_url" tabIndex={-1} autoComplete="off" defaultValue="" />
        </label>
      </div>
    </>
  );
};

export default FormGuard;
